<div class="relative lg:px-3 pb-2 lg:pt-2 lg:border-2 lg:border-transparent lg:hover:border-black lg:transition-colors lg:duration-300">
  <div class="flex flex-col">
    <div class="flex items-center gap-2">
      <div class="bg-black rounded-full h-[22px] w-[22px] lg:h-[26px] lg:w-[26px] flex items-center justify-center">
        <img src="assets/icons/search.png" class="w-[13px] h-[13px] lg:w-[17px] lg:h-[17px]">
      </div>
      <label>
        {{ allDealerList ? 'Bevorzugten Toyota-Vertragspartner auswählen' : 'Bevorzugten Lexus-Vertragspartner auswählen' }}
      </label>
    </div>

    <input
      #inputElement
      [formControl]="dealerControl"
      type="text"
      placeholder="Name, Straße, Postleitzahl oder Ort eingeben"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInputChange($event)"
      autocomplete="off"
      class="mt-2 w-full p-2 h-[41px] focus:outline-none border-b border-lighterText"
    />
  </div>

  @if (dropdownVisible) {
    <ul class="absolute z-10 mt-1 max-h-60 w-full overflow-auto bg-white border border-gray-300 rounded shadow-lg">
      @for (dealer of filteredDealers; track dealer.dealerNumber) {
        <li
          (mousedown)="$event.preventDefault()"
          (click)="selectDealer(dealer)"
          class="cursor-pointer px-3 py-2 hover:bg-lighterText hover:text-white [&:hover>div]:text-white"
        >
          <div class="font-semibold">{{ dealer.name }}</div>
          <div class="text-xs text-gray-600">{{ dealer.street }}, {{ dealer.postcode }} {{ dealer.city }}</div>
        </li>
      }
      @if (noResults) {
        <li class="px-3 py-2">
          Kein Ergebnis
        </li>
      }
    </ul>
  }
</div>
